import { CustomFieldValue } from '../../../../../types/custom_field';
import { ProductMasterData } from '../../../../../types/product_master_data/productMasterData';
import { ProductTransaction } from '../../../../../types/productTransaction';
import { UnitOfMeasure } from '../../../../../types/uom';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

export enum PdfProductTransactionProperty {
  quantity = 'quantity',
  processedQuantity = 'processedQuantity',
}

export class PdfProductTransactionDataResolver extends PdfEntityDataResolver<
  ProductTransaction,
  PdfProductTransactionProperty
> {
  constructor(readonly productMasterData: Map<string, ProductMasterData>) {
    super();
  }

  properties = Object.values(PdfProductTransactionProperty);
  entityType = PdfFieldEntity.productTransaction;

  getCustomFieldByEntity(entity: ProductTransaction, id: string): CustomFieldValue | undefined {
    return entity.customFields.get(id);
  }

  getLabelByProperty(property: PdfProductTransactionProperty): string {
    switch (property) {
      case PdfProductTransactionProperty.quantity:
        return 'Quantity';
      case PdfProductTransactionProperty.processedQuantity:
        return 'Processed Quantity';
    }
  }

  getValueByProperty(property: PdfProductTransactionProperty, entity: ProductTransaction): string {
    const pmd = this.productMasterData.get(entity.product.pmdId || '');

    switch (property) {
      case PdfProductTransactionProperty.quantity:
        const quantity = entity.product.quantity.toString();
        if (!entity.product.pmdId) return quantity;

        if (!pmd) {
          console.error(`Pmd with id ${entity.product.pmdId} not found`);
          return quantity;
        }

        return `${UnitOfMeasure.toQuantityWithSuffix(pmd.unitOfMeasure, quantity)}`;
      case PdfProductTransactionProperty.processedQuantity:
        if (!entity.product.processedQuantity) return '';
        const processedQuantity = entity.product.processedQuantity.toString();
        if (!entity.product.pmdId) return processedQuantity;

        if (!pmd) {
          console.error(`Pmd with id ${entity.product.pmdId} not found`);
          return processedQuantity;
        }

        return `${UnitOfMeasure.toQuantityWithSuffix(pmd.unitOfMeasure, processedQuantity)}`;
    }
  }
}
